import { memo, useCallback, useContext } from 'react';
import { DeleteIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { MediaPlaybackControlsContext } from '../context/MediaPlaybackControlsContext';
import { getParsedPlayerStatuses } from '../utils/getParsedPlayerStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
const __RecordingDeleteButton = ({
  onClick
}) => {
  const {
    status,
    pause
  } = useContext(MediaPlaybackControlsContext);
  const isPaused = getParsedPlayerStatuses(status).isPaused;
  const handleClick = useCallback(() => {
    if (!isPaused) {
      pause();
    }
    onClick();
  }, [isPaused, pause, onClick]);
  return /*#__PURE__*/_jsx(IconButton, {
    "data-selenium-test": "call-recording-delete-button",
    "data-test-id": "call-recording-delete-button",
    onClick: handleClick,
    size: "md",
    use: "link",
    children: /*#__PURE__*/_jsx(DeleteIcon, {})
  });
};
export const RecordingDeleteButton = /*#__PURE__*/memo(__RecordingDeleteButton);